import {ROLE_METADATA} from 'app/permissions/role-metadata';
import {DepartureRolesArray} from 'app/permissions/types';
import {DeparturePermissions} from '../../../../../permissions/departure-permissions';

export interface PermissionsMutationEvent {
  createdBy: string;
  role: string;
  people: string[];
  removed?: string[];
}

export class PermissionStateDiffer {
  private pushIfValid(event: PermissionsMutationEvent, events: PermissionsMutationEvent[]): void {
    if (event.people.length || (event.removed && event.removed.length)) {
      events.push(event);
    }
  }

  public diff(curr: DeparturePermissions, prev: DeparturePermissions): PermissionsMutationEvent[] {
    const permissionsObjects: PermissionsMutationEvent[] = [];

    if (curr) {
      prev = prev || {departureId: curr.departureId};
      DepartureRolesArray.forEach((role: string) => {
        if (ROLE_METADATA[role].multi) {
          this.pushIfValid(
            {
              createdBy: curr.createdBy,
              role: ROLE_METADATA[role].singularName,
              people: this._generateArrayOfAddedElements(curr[role], prev[role]),
              removed: this._generateArrayOfRemovedElements(curr[role], prev[role])
            },
            permissionsObjects
          );
        } else {
          this.pushIfValid(
            {
              createdBy: curr.createdBy,
              role: ROLE_METADATA[role].displayName,
              people: this._compareField(curr[role], prev[role]),
              removed: this._calculateRemoved(curr[role], prev[role])
            },
            permissionsObjects
          );
        }
      });
    }
    return permissionsObjects;
  }

  /**
   * compares two arrays and returns an array of elements
   * which have been added to the new array
   */
  private _generateArrayOfAddedElements(array1: string[], array2: string[]): string[] {
    array1 = array1 || [];
    array2 = array2 || [];
    return array1.filter(str => array2.indexOf(str) === -1);
  }

  /**
   * compares two arrays and returns an array of elements
   * which have been removed in the new array
   */
  private _generateArrayOfRemovedElements(array1: string[], array2: string[]): string[] {
    array1 = array1 || [];
    array2 = array2 || [];
    return array2.filter(str => array1.indexOf(str) === -1);
  }

  /**
   * compares two strings and returns the new string
   * if it is different from the first one.
   */
  private _compareField(newString: string, previousString: string): string[] {
    if (newString) {
      return newString !== previousString ? [newString] : [];
    } else {
      return [];
    }
  }

  /**
   * calculates an unassignment.
   * compares two values, if the previous is truthy and the second is falsy, return the previous
   */
  private _calculateRemoved(newString: string, previousString: string): string[] {
    return !!previousString && !newString ? [previousString] : [];
  }
}
